import { render, staticRenderFns } from "./InsuranceEdit.vue?vue&type=template&id=36b18680&"
import script from "./InsuranceEdit.vue?vue&type=script&lang=js&"
export * from "./InsuranceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports